import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ParametrosTurno } from "./ParametrosTurno";

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      padding:10,
      marginTop:-45
    }
}));

export const NuevoTurno = (props) => {
  const classes = useStyles();
  const { otroTurno, setOtroTurno, presencial, setPresencial, virtual, setVirtual, idEspecialidad, idCentroMedico,
    idProfesional, primeroDisponible, handleInputChange, setPrimeroDisponible, filtrarEdad, handleChangeFiltrarEdad,
    handleInputChangePorProfesional, idObraSocial, desdeHce} = props;
  
  return (
    <div className={classes.root}>  
        <ParametrosTurno
          otroTurno={otroTurno}
          setOtroTurno={setOtroTurno}
          presencial={presencial}
          setPresencial={setPresencial}
          virtual={virtual}
          setVirtual={setVirtual}
          filtrarEdad={filtrarEdad}
          idEspecialidad={idEspecialidad}
          idCentroMedico={idCentroMedico}
          idProfesional={idProfesional}
          primeroDisponible={primeroDisponible}
          handleInputChange={handleInputChange}
          setPrimeroDisponible={setPrimeroDisponible}
          handleChangeFiltrarEdad={handleChangeFiltrarEdad}
          handleInputChangePorProfesional={handleInputChangePorProfesional}
          idObraSocial={idObraSocial}
          desdeHce={desdeHce}
        />
    </div>
  );

};
